import { useEffect, useRef } from 'react';
import AvatarManager from '@/helpers/avatarManager';
import { FaceCameraManager } from '@/helpers/faceCameraManager';
import { ICanvasElement } from '@/interface/canvas';

type AvatarCanvasProps = {
  faceConfig: ICanvasElement;
  width: number;
  height: number;
};
const FaceCanvas = ({ faceConfig, width, height }: AvatarCanvasProps) => {
  const avatarManagerRef = useRef<AvatarManager>(AvatarManager.getInstance());

  const onLoadFace = async () => {
    await avatarManagerRef.current.loadFaceV2(faceConfig, height, width);

    const faceCameraManager = FaceCameraManager.getInstance();
    faceCameraManager.startCamera();
  };

  useEffect(() => {
    onLoadFace();
  }, []);
  return (
    <div
      className="absolute h-full w-full"
      id="face_canvas"
      style={{ height, width }}
    ></div>
  );
};

export default FaceCanvas;
